import React from 'react';
import { Splash } from './Splash';

type AppProps = {
    csrfToken: string;
    redesignEnabled: boolean
};

export function App(props: AppProps) {
    return <Splash csrfToken={props.csrfToken} redesignEnabled={props.redesignEnabled} />;
}
